<template>
  <el-dialog
    title="添加"
    :visible.sync="dialogVisible"
    width="40%"
    class="addIndustryDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="addActivityFrom" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="基地名称" prop="name">
            <div class="agendaRow">
              <el-input v-model="formData.name" />
            </div>
          </el-form-item>
        </el-col>
      </el-row><el-row>
        <el-col :span="24">
          <el-form-item label="对应部门" prop="deptPath">
            <el-cascader
              filterable
              ref="deptCascader"
              :props="props"
              v-model="formData.deptPath"
              :show-all-levels="false"
            />
          </el-form-item>
        </el-col>
      </el-row><el-row>
        <el-col :span="24">
          <el-form-item label="联系方式" prop="contactInformation">
            <div class="agendaRow">
              <el-input v-model="formData.contactInformation" />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="基地图片">
            <el-upload
              class="upload"
              :action="baseUrl"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-progress="uploadVideoProcess"
              :show-file-list="false"
            >
              <div>
                <el-button type="primary"><i class="iconfont icon-shangchuan-icon1" />添加</el-button>
              </div>
            </el-upload>
            <div class="file-box" v-for="item in fileList" :key="item.fileId">
              <span>{{ item.name }}</span>
              <i class="iconfont icon--s-guanbi closeIconFont" @click="beforeRemove(index)" />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  approvalManagementApi, expensesJurManagementApi
} from '../../service';
import { newApplicationFormApi } from '../../../newApplicationForm/service';
import { arrayQuery } from '@/utils/utils';
import { isNotEmpty } from '../../../../utils/utils';
export default {
  data () {
    return {
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad (node, resolve) {
          const { level } = node;
          let params = '000';
          if (level > 0) {
            params = node.value;
          }
          if (!node.isLeaf) {
            expensesJurManagementApi.getAllDeptList(params).then(res => {
              if (res.status === '200') {
                let nodeList = res.data.map(item => {
                  return {
                    label: item.deptName,
                    value: item.deptCode,
                    leaf: item.type !== '1'
                  };
                });
                resolve(nodeList);
              }
            });
          } else {
            resolve();
          }
        }
      },
      rules: {
        name: [
          { required: true, message: '请输入基地名称', trigger: 'blur' }
        ],
        deptPath: [
          { required: true, message: '请选择对应部门', trigger: 'change' }
        ],
        contactInformation: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ]
      },
      formData: {},
      applyDeptList: [],
      dialogVisible: false,
      applyDeptLoading: false,
      fileList: [],
      baseUrl: window._env_.VUE_APP_FILESERVICE_URL,
      progressFlag: false
    };
  },
  props: {
    addIndustryDialogShow: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    addIndustryDialogShow (val) {
      if (val) {
        if (this.rowData.id) {
          this.formData = this.rowData;
          this.$set(this.formData, 'deptPath', JSON.parse(this.rowData.deptPath));
          this.fileList.push({ fileId: this.rowData.imageUrl, name: this.rowData.imageName });
        }
      } else {
        this.formData = {};
        this.fileList = [];
        this.applyDeptList = [];
        this.$nextTick(() => {
          this.$refs.addActivityFrom.clearValidate();
        });
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    beforeUpload (file) {
      return new Promise((resolve, reject) => {
        let fileSize = file.size / 1024 / 1024 < 10;
        if (!fileSize) {
          this.$message.error('上传的文件大小不能超过10M');
          reject(new Error('上传的文件大小不能超过10M'));
          return false;
        }
        newApplicationFormApi.getFileToken().then(res => {
          if (res.status === '200') {
            if (this.baseUrl.indexOf('?Token=') < 0) {
              this.baseUrl = this.baseUrl + '?Token=' + res.data;
            }
            this.loadProgress = 0;
            this.fileList.push({
              name: file.name
            });
            resolve();
          } else {
            reject(res.status);
          }
        });
      });
    },
    handleSuccess (response, file, fileList) {
      if (response.status === '200' && response.data[0].FID) {
        this.loadProgress = 100;
        let fileIndex = this.fileList.findIndex(item => item.name === response.data[0].FullName);
        this.fileList[fileIndex].fileId = response.data[0].FID;
        setTimeout(() => {
          this.progressFlag = false;
        }, 800);
      } else {
        this.fileList.splice(this.fileList.length - 1, 1);
        this.progressFlag = false;
        this.$message.error(response.err);
      }
      this.baseUrl = this.baseUrl.split('?Token')[0];
    },
    beforeRemove (index) {
      // 如果文件删除成功则报错
      this.fileList.splice(index, 1);
    },
    uploadVideoProcess (event, file, fileList) {
      this.progressFlag = true;
      if (event.percent >= 100) {
        let interval = setInterval(() => {
          this.loadProgress += 20;
          if (this.loadProgress >= 99) {
            this.loadProgress = 99;
            clearInterval(interval);
          }
        }, 100);
      }
    },
    agendaDelBtn (index) {
      this.agendaList.splice(index, 1);
    },
    agendaAddBtn () {
      this.agendaList.push('');
    },
    dialogCloseHandle () {
      this.$emit('dialogClose');
    },
    submitHandlen () {
      this.$refs['addActivityFrom'].validate((valid) => {
        if (valid) {
          if (!isNotEmpty(this.fileList)) {
            this.$message.error('请上传图片');
            return false;
          }
          const { deptPath, name, contactInformation } = this.formData;
          let params = {
            deptName: this.$refs['deptCascader'].getCheckedNodes()[0].label,
            deptCode: deptPath[deptPath.length - 1],
            deptPath: JSON.stringify(deptPath),
            name,
            contactInformation,
            imageUrl: isNotEmpty(this.fileList) ? this.fileList[0].fileId : '',
            imageName: isNotEmpty(this.fileList) ? this.fileList[0].name : ''
          };
          if (this.formData.id) {
            params.id = this.formData.id;
            this.$emit('editActivityHandle', params);
          } else {
            this.$emit('addActivityHandle', params);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.agendaRow{
  padding-right: 36px;
  position: relative;
  >.el-input{
    margin-bottom: 10px;
  }
  >i{
    color: #DC5650;
    font-size: 16px;
    position: absolute;
    top: 0;
    right: 8px;
    cursor: pointer;
  }
}
.closeIconFont{
  display: none;
  vertical-align: middle;
  font-size: 16px;
  cursor: pointer;
  color: #dc5650;
}
.file-box:hover .closeIconFont{
  display: inline-block;
  margin-left: 5px;
}
.el-progress{
  width: 300px;
  display: inline-block;
}

</style>
